const divorcePlannerBoxStyle = {
  paper: {
    padding: "25px",
  },
};

export default divorcePlannerBoxStyle;
